// src/pages/PaymentCancelled.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from '../analytics';

function PaymentCancelled() {
    useEffect(() => {
        trackEvent('checkout_cancel');
    }, []);
    return (
        <div className="payment-result-page">
            <h2>Payment Cancelled</h2>
            <p>Your subscription process was cancelled. You have not been charged.</p>
            <p>You can return to the pricing page to try again at any time.</p>
            <Link to="/pricing" className="button">Back to Pricing</Link>
        </div>
    );
}

export default PaymentCancelled;
